import crown from '~/assets/icons/crown.svg';
import trash from '~/assets/icons/trash.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import {
	StyledButtonsContainer,
	StyledContainer,
	StyledNameContainer,
} from './AppTruckJobGroupMember.styled';

const AppTruckJobGroupMember = ({
	name,
	isLeader,
	isMe,
	canEdit,
}: {
	name: string;
	isLeader: boolean;
	isMe: boolean;
	canEdit: boolean;
}) => {
	return (
		<StyledContainer $isLeader={isLeader}>
			<StyledNameContainer>
				{isLeader && (
					<ImgIcon icon={crown} width={16} height={16} color="#FFBB00" />
				)}
				<Text>
					{name} {isMe && <span>(Вы)</span>}
				</Text>
			</StyledNameContainer>
			<Text
				style={{
					fontSize: 14,
					color: isLeader ? '#FFBB00' : '#ffffff',
					fontWeight: 500,
					textAlign: 'center',
				}}
			>
				{isLeader ? 'Лидер конвоя' : 'Участник'}
			</Text>
			<StyledButtonsContainer>
				<Button
					height={ButtonHeight.Height30}
					color={ButtonColors.Cancel}
					borderRadius={ButtonBorderRadius.Radius5}
					disabled={!canEdit}
					square
				>
					<img src={trash} width={14} height={14} />
				</Button>
				<Button
					height={ButtonHeight.Height30}
					color={ButtonColors.Gold2}
					borderRadius={ButtonBorderRadius.Radius5}
					square
					disabled={!canEdit}
				>
					<ImgIcon icon={crown} width={14} height={14} color="#000000" />
				</Button>
			</StyledButtonsContainer>
		</StyledContainer>
	);
};

export { AppTruckJobGroupMember };
